import type { CounterProps } from "@/scott/ui/blocks/counter/counter-section";
import { getBlockId } from "@/services/contentful/assemblies/page/adapter/utils";
import {
  UiConfigurationAdapter,
  type UiConfigurationInput,
} from "@/services/contentful/topics/UIConfiguration/ui-configuration.adapter";
import type { PageBlock, RawContentBlockBase } from "@/types/page-block";

export type RawCounterItem = {
  sys?: { id?: string };
  prefix: string | null;
  value: number;
  suffix: string | null;
  subline: string | null;
};

export type RawSectionCounterBlock = RawContentBlockBase &
  Omit<CounterProps, "items"> & {
    __typename: "SectionCounter";
    footnote?: string | null;
    itemsCollection?: {
      items?: Array<RawCounterItem | null> | null;
    } | null;
    uiConfiguration?: UiConfigurationInput;
  };

function mapCounterItems(
  items: Array<RawCounterItem | null> | null | undefined
): CounterProps["items"] {
  if (!items) {
    return [];
  }

  return items
    .filter((counterItem): counterItem is RawCounterItem => counterItem != null)
    .map((counterItem) => ({
      sys: counterItem.sys,
      value: counterItem.value,
      label: counterItem.subline ?? "",
      prefix: counterItem.prefix ?? undefined,
      suffix: counterItem.suffix ?? undefined,
    }));
}

export function SectionCounterAdapter(
  item: RawSectionCounterBlock,
  index: number
): PageBlock {
  const blockId = getBlockId(item, index);
  const uiConfig = item.uiConfiguration
    ? UiConfigurationAdapter(item.uiConfiguration)
    : undefined;

  return {
    sys: item.sys,
    id: blockId,
    __typename: item.__typename,
    internalName: item.internalName ?? "",
    footnote: item.footnote ?? undefined,
    paddingTop: uiConfig?.paddingTop,
    paddingBottom: uiConfig?.paddingBottom,
    backgroundColor: uiConfig?.backgroundColor,
    color: uiConfig?.textColor,
    columnWidth: item.columnWidth,
    items: mapCounterItems(item.itemsCollection?.items),
  };
}
